import React from 'react';
import { ArrowRight } from 'lucide-react';
import { personalInfo } from '../data/mock';

const ZahaHero = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#f7fafc] via-white to-[#edf2f7] pt-20">
      {/* Organic flowing shapes */}
      <div className="absolute top-0 right-0 w-[1200px] h-[1200px] opacity-[0.15] zaha-float">
        <div className="w-full h-full bg-gradient-to-br from-[#cbd5e0] to-transparent" style={{
          borderRadius: '63% 37% 54% 46% / 55% 48% 52% 45%'
        }} />
      </div>
      
      <div className="absolute bottom-0 left-0 w-[800px] h-[800px] opacity-[0.12]" style={{
        animation: 'float-smooth 10s ease-in-out infinite'
      }}>
        <div className="w-full h-full bg-gradient-to-tr from-[#a0aec0] to-transparent" style={{
          borderRadius: '47% 53% 42% 58% / 63% 52% 48% 37%'
        }} />
      </div>

      {/* Same container as header */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 py-20 md:py-32">
        {/* Centered Content */}
        <div className="flex flex-col items-center justify-center text-center space-y-8 md:space-y-12">
          {/* Small label above name */}
          <div>
            <p className="text-xs font-medium text-[#a0aec0] uppercase tracking-[0.3em]">
              Security Systems Engineer
            </p>
          </div>
          
          {/* Main Name - Hero - Single Row */}
          <div className="space-y-2 md:space-y-4">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl font-light text-[#2d3748] leading-[0.85] tracking-wider whitespace-nowrap">
              ABNER PALLICHAN
            </h1>
          </div>

          {/* Bio */}
          <p className="text-base md:text-lg text-[#718096] max-w-3xl leading-relaxed font-light px-4">
            {personalInfo.bio}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 pt-4 md:pt-8">
            <button
              onClick={(e) => scrollToSection(e, '#work')}
              className="group relative px-8 md:px-10 py-4 md:py-5 bg-[#2d3748] text-white overflow-hidden"
              style={{ borderRadius: '50px 30px 50px 30px' }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-[#4a5568] to-[#2d3748] opacity-0 group-hover:opacity-100 transition-opacity" />
              <span className="relative flex items-center gap-2 md:gap-3 text-xs md:text-sm font-medium tracking-wide">
                View Portfolio
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </span>
            </button>
            
            <button
              onClick={(e) => scrollToSection(e, '#contact')}
              className="px-8 md:px-10 py-4 md:py-5 border border-[#cbd5e0] text-[#4a5568] hover:border-[#2d3748] hover:bg-[#f7fafc] transition-all"
              style={{ borderRadius: '30px 50px 30px 50px' }}
            >
              <span className="text-xs md:text-sm font-medium tracking-wide">Get in Touch</span>
            </button>
          </div>

          {/* Stats - Centered */}
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 pt-8 md:pt-16">
            {[
              { value: '3+', label: 'Years Experience' },
              { value: '25+', label: 'Projects Delivered' },
              { value: '10+', label: 'Healthcare Facilities' }
            ].map((stat, idx) => (
              <div key={idx} className="text-center">
                <p className="text-4xl md:text-5xl font-light text-[#2d3748] mb-2">{stat.value}</p>
                <p className="text-xs text-[#a0aec0] uppercase tracking-wider">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* Specialization & Side Project - Centered Cards */}
          <div className="grid sm:grid-cols-2 gap-6 md:gap-8 max-w-4xl w-full pt-8 md:pt-16">
            <div className="bg-gradient-to-br from-[#f7fafc] to-white p-6 md:p-8 zaha-shadow text-center"
              style={{ borderRadius: '40px 30px 40px 30px' }}
            >
              <p className="text-xs font-medium text-[#a0aec0] uppercase tracking-wider mb-4">Specialization</p>
              <h3 className="text-xl md:text-2xl font-medium text-[#2d3748] mb-4 md:mb-6">
                Security Systems
                <br />
                Engineering
              </h3>
              <div className="space-y-2 md:space-y-3">
                {[
                  'Healthcare Infrastructure',
                  'Access Control Systems',
                  'Nurse Call Systems'
                ].map((item, idx) => (
                  <p key={idx} className="text-xs md:text-sm text-[#718096]">{item}</p>
                ))}
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#2d3748] to-[#4a5568] p-6 md:p-8 text-white text-center"
              style={{ borderRadius: '40px 30px 40px 30px' }}
            >
              <p className="text-xs font-medium text-white/60 uppercase tracking-wider mb-4">Creative Side</p>
              <h3 className="text-xl md:text-2xl font-medium text-white mb-4 md:mb-6">
                DJ / Music
                <br />
                Curator
              </h3>
              <p className="text-xs md:text-sm text-white/80">Underground Garage, Techno & House</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZahaHero;